import { COMPANY_FILTER_CHANGE } from '../../PartnerOptions/constants'
import { CHANGE_INCIDENT_STATE_REQUEST_ASYNC } from '../AtoIncident/Header/constants'
import { REGULAR_FILTERS_SUBMIT } from '../IncidentFilters/constants'
import { QUICK_FILTERS_CHANGE } from '../QuickFilters/constants'
import {
  CLOSE_INCIDENT_ASYNC,
  CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC,
  RELEASE_MSFT_QUARANTINE_REPORT_ASYNC,
  REPORT_STATE_CHANGE_ASYNC,
} from '../Report/constants'
import {
  CHALLENGED_TYPE_FILTER_CHANGE,
  GENERAL_FILTER_CHANGE,
  SEARCH_CHANGE,
  SORTING_FILTER_CHANGE,
} from '../TopBar/constants'

import { LIST_REQUEST_ASYNC, PAGINATE_CHANGE, REPORT_SELECT, URL_STATE_CHANGE } from './constants'

export default function () {
  const initialState = {
    data: {
      reports: {
        results: [],
      },
    },
    loader: false,
    selectedReportId: null,
    selectedReportType: null,
    urlState: null,
    error: null,
    page: 1,
    firstPageLoadDate: '',
    lastRowDate: '',
    // true when the last PAGINATE_CHANGE was a direct jump (offset, not cursor-append)
    pageJump: false,
  }

  return (state = initialState, action) => {
    switch (action.type) {
      case SEARCH_CHANGE:
      case SORTING_FILTER_CHANGE:
      case GENERAL_FILTER_CHANGE:
      case QUICK_FILTERS_CHANGE:
      case REGULAR_FILTERS_SUBMIT:
      case COMPANY_FILTER_CHANGE:
      case CHALLENGED_TYPE_FILTER_CHANGE:
      case RELEASE_MSFT_QUARANTINE_REPORT_ASYNC.SUCCESS:
      case CLOSE_INCIDENT_ASYNC.SUCCESS:
      case CLOSE_SAFE_CHALLENGE_INCIDENT_ASYNC.SUCCESS:
      case CHANGE_INCIDENT_STATE_REQUEST_ASYNC.SUCCESS:
        return {
          ...state,
          loader: true,
          selectedReportId: null,
          selectedReportType: null,
          page: 1,
          firstPageLoadDate: '',
          lastRowDate: '',
          // Company switches keep the previous scanBackCount until the next
          // success. Remember that so a failed request cannot be read as the
          // new company's loaded inventory. Other refetches leave it alone.
          ...(action.type === COMPANY_FILTER_CHANGE ? { scanBackCountStale: true } : {}),
        }
      case REPORT_STATE_CHANGE_ASYNC.SUCCESS:
        return {
          ...state,
          loader: true,
          page: 1,
          firstPageLoadDate: '',
          lastRowDate: '',
        }
      case PAGINATE_CHANGE: {
        const { page: targetPage } = action.payload
        const isFirstPage = targetPage === 1
        // Three call sites share this action — keep them distinct:
        //   • Legacy List infinite-scroll sentinel → paginateChange()      (targetPage undefined)
        //     Cursor append: page++, keep lastRowDate, SUCCESS concatenates results.
        //   • Legacy "back to top" / redesign reset → paginateChange(1)
        //   • Redesign numbered pager (incl. 1→2) → paginateChange(n>1)   (offset replace + loader)
        // Never treat a bare paginateChange() as a page jump — that would break legacy load-more.
        const isPageJump = targetPage !== undefined && !isFirstPage
        return {
          ...state,
          page: targetPage ?? state.page + 1,
          // Page jump: show loader + replace results; reset cursor so BE uses offset.
          // Load-more append: no loader, keep the cursor.
          loader: isFirstPage || isPageJump,
          pageJump: isPageJump,
          selectedReportId: isFirstPage ? null : state.selectedReportId,
          selectedReportType: isFirstPage ? null : state.selectedReportType,
          firstPageLoadDate: isFirstPage ? '' : state.firstPageLoadDate,
          // Clear cursor so the backend uses page-number offset for the jump.
          lastRowDate: isFirstPage || isPageJump ? '' : state.lastRowDate,
        }
      }

      case URL_STATE_CHANGE:
        return {
          ...state,
          loader: true,
          urlState: action.payload.urlState,
          selectedReportId: null,
          selectedReportType: null,
          page: 1,
          pageJump: false,
          firstPageLoadDate: '',
          lastRowDate: '',
          // Incidents and Scan Back share this slice. Drop the previous tab's
          // rows so the next screen cannot paint them while its fetch is in flight.
          data: {
            ...state.data,
            totalCount: undefined,
            hasMore: false,
            reports: {
              ...(state.data?.reports || {}),
              results: [],
            },
          },
        }
      case REPORT_SELECT:
        return {
          ...state,
          selectedReportId: action.payload.id,
          selectedReportType: action.payload.type,
        }
      case LIST_REQUEST_ASYNC.INITIATE:
        return {
          ...state,
          error: null,
          // A background poll must not dismiss a loader that a real fetch already
          // turned on — that was painting the previous tab's rows on Scan Back.
          loader: action.payload.isPolling ? state.loader : true,
        }
      case LIST_REQUEST_ASYNC.SUCCESS: {
        const items = action.payload.data.reports.results
        const isSelectedItemInsideList =
          state.selectedReportId && items.some((item) => item.id === state.selectedReportId)

        // Page jump: replace the entire result list for the jumped-to page (offset fetch).
        // Append (load-more, page > 1, no jump): concatenate new items onto the existing list.
        // First page: always replace.
        const shouldAppend = state.page > 1 && !state.pageJump
        return {
          ...state,
          error: null,
          loader: false,
          pageJump: false,
          data: shouldAppend
            ? {
                ...action.payload.data,
                reports: {
                  results: [...state.data.reports.results, ...items],
                },
              }
            : action.payload.data,
          selectedReportId:
            isSelectedItemInsideList || shouldAppend
              ? state.selectedReportId
              : items[0]?.id || null,
          selectedReportType:
            isSelectedItemInsideList || shouldAppend
              ? state.selectedReportType
              : items[0]?.reportType || null,
          firstPageLoadDate: action.payload.data.firstPageLoadDate,
          lastRowDate: action.payload.data.lastRowDate,
          scanBackCountStale: false,
        }
      }
      case LIST_REQUEST_ASYNC.ERROR:
        return {
          ...state,
          loader: false,
          error: action.error,
          scanBackCountStale: false,
          data: state.scanBackCountStale ? { ...state.data, scanBackCount: undefined } : state.data,
        }
      case LIST_REQUEST_ASYNC.CANCEL:
        return {
          ...state,
          loader: false,
          page: 1,
        }
      default:
        return state
    }
  }
}
